<template>
  <v-dialog v-model="show" max-width="600px">
    <v-card>
      <v-card-title style="padding-left: 8px; padding-bottom: 8px">
        <span class="headline">{{ $t('app.messages.errors.title') }}</span>
      </v-card-title>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md12 sm12 xs12>
              <div style="text-align: center">
                PackingList のItemNo：<span style="color: red">{{
                  itemNo
                }}</span
                >がＰＯと不一致です。
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md12 sm12 xs12>
              <div style="text-align: center">
                <v-btn @click="close">确定</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      itemNo: '',
      show: false,
    }
  },
  methods: {
    popup(itemNo) {
      this.show = true
      this.itemNo = itemNo
    },
    close() {
      this.show = false
    },
  },
}
</script>
